import Footer from "@/components/footer/Footer";
import type { IconName } from "@/components/icon/IconName";
import Navbar from "@/components/navbar/Navbar";
import { LOGIN, RESET_PASSWORD } from "@/constant/routes";
import { AuthContext, type AuthContextProps } from "@/contexts/auth/Auth";
import { LoadingScreen } from "@/features/loading-screen";
import { useSupabaseClient } from "@/hooks/useSupabaseClient";
import React, { Suspense, useContext, useEffect, useState } from "react";


import { Navigate, useNavigate } from "react-router-dom";

interface PrivateRouteProps {
  children: React.ReactNode;
}
const supabase = useSupabaseClient();

export const PrivateRoute: React.FC<PrivateRouteProps> = ({ children }) => {
    const { user, loading, signOut } = useContext(AuthContext) as AuthContextProps;
    const [ displayName, setDisplayName ] = useState("");
    const navigate = useNavigate();

    const getDisplayName = async () => {
            const { data, error } = await supabase.rpc("get_full_name")
            if (error) {
                console.error(error);
                return;
        
            }
        
            setDisplayName(data)
    };

    useEffect(() => {

      getDisplayName();

    },[]);

    const selectItems = [
      {
        label: "Réinitialisation mot de passe",
        iconName: "password" as IconName,
        onClick: () => navigate(RESET_PASSWORD)
      },
      {
        label: "Se déconnecter",
        iconName: "logout" as IconName,
        onClick: () => signOut()
      },
    ];

    if (loading) {
      return <LoadingScreen />;
    }

    if (!user) {
      return <Navigate to={LOGIN} replace />;
    }

  return (
  <Suspense>
      <Navbar displayName={displayName} onClick={signOut} options={selectItems}/>
      {children}
      <Footer/>
  </Suspense>
  );
};
